// test906
(906 && 0);
